/** @format */

import React, { useContext, useEffect, useMemo } from "react";
import {
  TextField,
  Grid,
  Button,
  Paper,
  Typography,
  makeStyles,
  CssBaseline,
  Container,
  Box,
  Divider,
  Modal,
  Backdrop,
  Fade,
  IconButton,
  Card,
  CardContent,
  CardActions,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";

import UserContext from "../../context/Globales/UserContext";
import HelpIcon from "@material-ui/icons/Help";

//import InformerComercial from '/static/imagen/InformeComercialPlus1.png';
import { Alert, AlertTitle } from "@material-ui/lab";
import Loading from "../modales/Loading";
import Error from "../Error";

import { globales, mensajeglobales } from "../../helpers/Confi";

import swal from "sweetalert";
import { isMobile } from "react-device-detect";
import { DecodificanString } from "../../helpers/Codifican";
import { STATE_OK_LOADING_IC } from "../../context/types";

const useStyles = makeStyles((theme) => ({
  palette: {
    primary: {
      main: "#303f9f",
      color: "white",
    },
    secondary: {
      main: "#ff001e",
      backgroundColor: "#ff001e",
    },
  },

  paper: {
    margin: theme.spacing(5, 1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(0),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "90%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  submit: {
    width: "100%",
    margin: theme.spacing(1, 0, 2),
    padding: theme.spacing(1),
  },
  cancel: {
    width: "100%",
    margin: theme.spacing(2, 0, 1),
    padding: theme.spacing(1),
    color: "white",
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: "100vh",
  },

  modal: {
    display: "flex",
    alignItems: "left",
    justifyContent: "left",
    width: "auto",
    height: "auto",
  },
  Modalpaper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "50%",
  },
  mousePointer: { cursor: "pointer" },
}));

const FormInfoCom = () => {
  <CssBaseline />;
  
  const DatosTipoContrato = DecodificanString(localStorage.getItem("tipCont"))

  const userContext = useContext(UserContext);
  const {
    dispatch,
    datoIC,
    DvValidado,
    SerieCedulaNatu,
    DataContatoInfoCom,
    DataTipoContracto,
    DataSaldo,
    statOkLoading,
    calcularNroSerie,
  } = useContext(UserContext);

  const classes = useStyles();
  const navigate = useHistory();

  const [OpenModalAyudaCedula, setOpenModalAyudaCedula] = React.useState(false);
  const [Digdv, setDigdv] = React.useState(null);

  const [OpenLoading, setOpenLoading] = React.useState(
    JSON.parse(localStorage.getItem("stateLoading"))
  );

  const [error, seterror] = React.useState(false);
  //ASIGNOS LOS PARAMETROS PARA EL FORMULARIO
  const [RutFormularios, setRutFormularios] = React.useState({
    Rut: "",
    serieCedula: "",
    Dv: "",
  });

  const { Rut, Dv, serieCedula } = RutFormularios;

  const parametros = globales(); //  parametros globales:
  const MSG = mensajeglobales(); // mensaje globales;
  const id = DecodificanString(JSON.parse(localStorage.getItem("id")));
  const login = DecodificanString(JSON.parse(localStorage.getItem("login")));
  const clientId = localStorage.getItem("clientId");
  const ClienteIdd = DecodificanString(
    JSON.parse(localStorage.getItem("clientId"))
  );
  const ContratoId = DecodificanString(
    JSON.parse(localStorage.getItem("contractId"))
  );
  const { calcularDv } = require("validar-rut");

  useEffect(() => {
    StateSaldoPrepago(ClienteIdd, ContratoId);
    ValidarContrato(id, login, ClienteIdd);
    dispatch({ type: STATE_OK_LOADING_IC, payload: false });
    return () => {
      // userContext.getTipoContracto(ClienteIdd, ContratoId);

      setRutFormularios({
        Rut: "",
        serieCedula: "",
        Dv: "",
      });
      setDigdv(null);

      calcularNroSerie(Rut);
    };
  }, []);

  //? Obtengo los datos  si el usuario tiene producto asociado con el informe comercial
  const ValidarContrato = () => {
    userContext.getContractInfoCom(id, login, ClienteIdd, DataTipoContracto.Id);
  };

  useEffect(()=> {
    userContext.getContractInfoCom(id, login, ClienteIdd, DataTipoContracto.Id);
  }, [DataTipoContracto])

  const StateSaldoPrepago = (ClienteIdd, ContratoId) => {
    userContext.getTipoContracto(ClienteIdd, ContratoId);
  };

  // const stateinforme = JSON.parse(localStorage.getItem('ContratoInfoCom'));

  const handleChange = (e) => {
    setRutFormularios({
      ...RutFormularios,
      [e.target.name]: e.target.value,
    });
  };

  const calcularDvNumeroSerie = (Rut) => {
    if (Rut == " " || Rut == "" || Rut == 0) {
      seterror(true);
      setRutFormularios({
        Rut: "",
        serieCedula: "",
        Dv: "",
      });
      setDigdv(null);
      return;
    } else {
      setDigdv(calcularDv(Rut));
      calcularNroSerie(Rut);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setOpenLoading(true);

    if (
      DataContatoInfoCom.Exist ||
      JSON.parse(localStorage.getItem("ContratoInfoCom"))
    ) {
      if (Rut === "" || Rut === 0) {
        seterror(true);
        setOpenLoading(false);
        return;
      } else {
        // userContext.getInfoComercial(Rut, Dv, serieCedula);
        userContext.getInformeComercialNew(Rut, Digdv, serieCedula);
        seterror(false);

        userContext.tomarRutconsulta(Rut); //tomo los datos del rut para usarlo en donde puedad;
        userContext.getDetalleDocumentpch(Rut, Digdv);

        navigate.push(parametros.rutaServidor + "informeComercial-result");

        setOpenLoading(false);
      }
    } else {
      swal({
        title: "Atención",
        text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
        icon: "warning",
        button: "OK",
      });
    }
  };

  const handleClickModalCedula = () => {
    setOpenModalAyudaCedula(!OpenModalAyudaCedula);
  };

  const LimpiarForm = (Rut, Dv, serieCedula) => {
    setRutFormularios({
      Rut: "",
      serieCedula: "",
      Dv: "",
    });

    setDigdv(calcularDv(Rut));

    document.getElementById("RutFocus").focus(); //Asigno el curso de mouse el Rut
    seterror(false);
  };

  const handleError = () => {
    seterror(!error);
  };

  return (
    <div style={{ width: "100%" }}>
      <br />

      {OpenModalAyudaCedula ? (
        <Box my={15} elevation={5} display="flex" justifyContent="center">
          <Card
            style={{
              textAlign: "center",
              align: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Typography
              variant="h5"
              align="right"
              onClick={handleClickModalCedula}
              className={classes.mousePointer}
            >
              X
            </Typography>
            <CardContent>
              <Grid
                container
                direction="row"
                justifyContent="space-evenly"
                alignItems="center"
              >
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <img
                    src={process.env.PUBLIC_URL + "/static/imagen/rut_1.png"}
                    title="Ayuda Cedula"
                    alt="ayuda cédula"
                  />
                  <br />
                  <p style={{ textAlign: "center" }}>
                    Para cédulas posteriores a 2013, el número de serie se
                    encuentra en el anverso
                  </p>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={162}>
                  <img
                    src={process.env.PUBLIC_URL + "/static/imagen/rut_2.png"}
                    title="Ayuda Cedula"
                    alt="ayuda cédula"
                  />
                  <br />
                  <p style={{ textAlign: "center" }}>
                    Para cédulas anteriores a 2013, el número de serie se
                    encuentra al reverso
                  </p>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      ) : (
        ""
      )}
      {DataTipoContracto != null || DataSaldo != null ? (
        <>
          <Box display="flex" justifyContent="center">
            <CssBaseline />
            {DataTipoContracto.IsPrepago && DataSaldo.Saldo === 0 ? (
              <Alert severity="warning">
                <AlertTitle>
                  Atención su plan es: ({DataTipoContracto.Nombre})
                </AlertTitle>
                Pero no dispone de saldo para efectuar consulta —{" "}
                <strong>CONSULTE A SOPORTE</strong>{" "}
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => navigate.push("/viewsaldo")}
                >
                  VER CONSUMO
                </Button>
              </Alert>
            ) : (
              <Container maxWidth="sm" component={Paper} elevation={5}>
                {isMobile ? (
                  <>
                    <br />
                    <br />
                    <br />
                    <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => navigate.push("MenuMobile")}
                      >
                        Menú Principal
                      </Button>
                    </Grid>
                  </>
                ) : (
                  ""
                )}
                <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                  <Typography
                    component="h1"
                    variant="h4"
                    style={{ textAlign: "center", paddingTop: "5px" }}
                    className={classes.paper}
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/static/imagen.png"
                      }
                      style={{ width: "100px", height: "100px" }}
                      title="icono informe comercial"
                      alt="icono informe comercial"
                    ></img>{" "}
                    Informe Comercial{" "}
                  </Typography>
                </Grid>

                <Grid container justify="space-around" alignItems="center">
                  <form className={classes.form} autoComplete="off">
                    {error ? (
                      <Error
                        mensaje="Debes de indicar un rut Valido"
                        handleError={handleError}
                      />
                    ) : (
                      " "
                    )}

                    <Grid container justify="flex-start" spacing={2}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        xl={Digdv != null ? 9 : 12}
                        md={Digdv != null ? 9 : 12}
                        lg={Digdv != null ? 9 : 12}
                      >
                        <NumberFormat
                          fullWidth
                          customInput={TextField}
                          // format="########"
                          label="N° Rut "
                          margin="normal"
                          name="Rut"
                          id="RutFocus"
                          onChange={handleChange}
                          outoffocus={true.outoffocus}
                          onBlur={() => {
                            calcularDvNumeroSerie(Rut);
                          }}
                          value={Rut}
                          inputProps={{ maxLength: 8 }}
                          variant="outlined"
                        />
                      </Grid>
                      {Digdv != null ? (
                        <Grid item xs={12} sm={12} md={3} xl={3} lg={3}>
                          <TextField
                            fullWidth
                            label=""
                            margin="normal"
                            name="Dv"
                            onChange={handleChange}
                            value={Digdv}
                            inputProps={{ maxLength: 1 }}
                            variant="outlined"
                            disabled={true}
                          />
                        </Grid>
                      ) : (
                        ""
                      )}

                      <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                        <div className="container" hidden={SerieCedulaNatu}>
                          <TextField
                            fullWidth
                            label="N° Documento/Serie opcional"
                            margin="normal"
                            name="serieCedula"
                            onChange={handleChange}
                            value={serieCedula}
                            onClick={() => {
                              calcularDvNumeroSerie(Rut);
                            }}
                            inputProps={{ maxLength: 9 }}
                            variant="outlined"
                          />

                          <IconButton
                            color="primary"
                            aria-label="directions"
                            size="medium"
                            edge="start"
                            style={{ textAlign: "right" }}
                            onClick={handleClickModalCedula}
                          >
                            <HelpIcon />
                          </IconButton>
                        </div>
                      </Grid>
                    </Grid>

                    <Box my={2}>
                      <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={2}
                      >
                        <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                          {Rut.length >= 1 && Digdv == null ? (
                            <Button
                              color="secondary"
                              fullWidth
                              size="large"
                              variant="contained"
                              onClick={() => calcularDvNumeroSerie(Rut)}
                            >
                              Porfavor validar Rut
                            </Button>
                          ) : Rut.length >= 1 && Digdv != null ? (
                            <Button
                              color="secondary"
                              disabled={Rut.length > 0 ? false : true}
                              fullWidth
                              size="large"
                              onClick={handleSubmit}
                              variant="contained"
                            >
                              Consulta Informe Comercial
                            </Button>
                          ) : OpenLoading && Digdv != null ? (
                            <Button
                              color="secondary"
                              disabled={true}
                              fullWidth
                              size="large"
                              type="submit"
                              variant="contained"
                            >
                              Espere estamos procesando la información...
                            </Button>
                          ) : (
                            ""
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </form>
                  <Box my={2} className={classes.form}>
                    <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                      <Button
                        color="primary"
                        fullWidth
                        size="large"
                        type="submit"
                        variant="outlined"
                        onClick={() => {
                          LimpiarForm(Rut, Dv, serieCedula);
                        }}
                      >
                        Limpiar Formulario
                      </Button>
                    </Grid>
                  </Box>
                </Grid>
              </Container>
            )}
          </Box>
        </>
      ) : (
        <Box
          my={15}
          style={{ textAlign: "center", alignContent: "center", width: "100%" }}
        >
          <Card>
            <CardContent>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/static/imagen/algo-ha-salido-mal.png"
                }
                width="30%"
                title="algo ha salido mal"
                alt="algo a salido mal"
              ></img>
              <h1>Lo Sentimos</h1>
              <Divider />
              <p>No fuimos capaces de mostrar la información correctamente</p>
              {/* <p>{this.state.message}</p> */}
              <br />
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate.push("/");
                }}
              >
                Reintentar
              </Button>
            </CardContent>
          </Card>
        </Box>
      )}
      {statOkLoading ? <Loading /> : " "}
    </div>
  );
};
export default FormInfoCom;
